import { Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { ITraveller } from '../../../../../../../../data/api/models';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import * as React from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { renderProductDefinition } from '../../../../Helpers';
import { Button, Col, ControlLabel, Form, Grid, Row } from 'react-bootstrap';
import MTARemoveTravellers from '../Components/MTARemoveTravellers';
import SelectControl from '../../../../../../../../components/SelectControl';
import { isRequired } from '../../../../../../../../util/validators';
import { mapTraveller } from '../../../../../../../../helpers/Travellers';
import { FaSpinner } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { MTAButtons } from '../../../MTAButtons';
import './style.scss';

interface IMTARemoveTravellerFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  formValues: any;
  i18n: II18nMessages;
  selectedPolicy: any;
  groupType: string;
  travellers: ITraveller[];
  removalReason: string;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
  };
}

class MTARemoveTravellerForm extends React.Component<IMTARemoveTravellerFormProps, any> {

  constructor(props) {
    super(props);
    const { dispatch, change } = props;
    dispatch(change('page', PageForm.MTA_REMOVE_TRAVELLER));
    window.scrollTo(0, 0);

    this.handleOnchangeReason = this.handleOnchangeReason.bind(this)
  }

  public state = {
    showAddressField: false,
    travellersToRemove : [],
  };

  public handleSubmit = () => {
    const { actions, formValues, change } = this.props;

    // Filter by type, and remove the travellers listed in travellersToRemove.
    const adults = formValues.travellers.filter((traveller) => {
      return traveller.type === 'adult' && ! this.state.travellersToRemove.includes(traveller.id)
    }).map(mapTraveller('adult'));
    const children = formValues.travellers.filter((traveller) => {
      return traveller.type === 'child' && ! this.state.travellersToRemove.includes(traveller.id)
    }).map(mapTraveller('child'));

    Promise.all([
      Promise.resolve(this.changeTravellerGroupsOnRemoval(adults, children, change)),
      Promise.resolve(change('data.attributes.metadata.adults', adults)),
      Promise.resolve(change('data.attributes.metadata.children', children)),
      actions.mta.calculateMtaPremiums(),
    ]).then((data) => {
      actions.mta.addEndorsements();
      actions.mta.handleMTASubmit();
    });
  }

  private handleRemoveField = (id, fields) => () => this.removeField(id, fields);
  private handleRestoreField = (id) => () => this.restoreField(id);

  private getIndex = (id: string, fields) => {
    let travellerIndex = -1;
    const travellers = fields.getAll();

    travellers.forEach((traveller, index) => {
      if (traveller.id === id) {
        travellerIndex = index;
      }
    });

    if (travellerIndex === -1) {
      console.error('Couldn\'t find traveller', travellers, id, travellerIndex);
    }

    return travellerIndex;
  }

  private removeField = (id: string, fields) => {
    const travellerIndex = this.getIndex(id, fields);

    if (travellerIndex === -1) {
      return;
    }

    this.setState(prevState => ({
      travellersToRemove: [...prevState.travellersToRemove, id]
    }));
  }

  private restoreField = (travellerId: string) => {
    this.setState(prevState => ({
      travellersToRemove: prevState.travellersToRemove.filter((id) => {
        return id !== travellerId
      })
    }));
  }

  handleOnchangeReason(event, data) {
    const { change } = this.props
    change('data.attributes.metadata.traveller_remove_reason', data);
  }

  changeTravellerGroupsOnRemoval = (adults, children, change): boolean => {
    const { formValues } = this.props;
    const isGroup = get(formValues, 'metadata.traveller_group', '') === 'group'

    if (isGroup) {
      return true;
    }


    if (adults.length === 2 && !children.length) {
      change('data.attributes.metadata.traveller_group', 'couple')
    }

    if (adults.length === 2 && children.length) {
      change('data.attributes.metadata.traveller_group', 'family')
    }

    if (adults.length === 1 && !children.length) {
      change('data.attributes.metadata.traveller_group', 'individual')
    }

    if (adults.length === 1 && children.length) {
      change('data.attributes.metadata.traveller_group', 'family_one_adult')
    }
    return true;
  }

  public render() {
    const {
      handleSubmit, i18n, actions, mta, change,
      submitFailed, submitting, valid, groupType, travellers, selectedPolicy, removalReason
    } = this.props;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const policyNumber = get(mta, 'selectedPolicy.policyNumber', null);
    const isLoading = mta.isLoading;
    const showComponent = !removalReason || (removalReason && removalReason !== 'Other');

    const reasons = [
      { label: 'Not travelling soon', value: 'Not travelling soon' },
      { label: 'Duplicate Policy', value: 'Duplicate Policy' },
      { label: 'Limits not high enough', value: 'Limits not high enough' },
      {
        label: 'Not enough trips planned for Annual Multi Trip policy',
        value: 'Not enough trips planned for Annual Multi Trip policy'
      },
      { label: 'No longer required', value: 'No longer required' },
      { label: 'Other', value: 'Other' },
    ];

    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        bsSize="small"
        className="medium-width pull-right"
        disabled={submitting || (submitFailed && !valid) ||
          !valid || ! this.state.travellersToRemove.length || isLoading}
      >
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        Continue
      </Button>
    );

    const goBackButton = (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    );

    return (
      <>
        {showComponent && (
          <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off" style={{marginTop: '15px'}}>
            <div className="admiral-card">
              <div className={'p-details-overview-header'}>
                <div className={'p-d-overview-icon'}>
                  <img height={'36px'} style={{ marginRight: '10px' }} src={require('../../../../../../../CustomerAreaNew/scenes/MakeAChange/Images/bin.svg')}
                       alt={'Remove traveller icon'}/>
                </div>
                <div>
                  <div className={'p-d-overview-text'}>
                    Remove Traveller
                  </div>
                </div>
              </div>
              <div className="body">
                <Grid fluid={true}>
                  <Row className={'dynamic-row'}>
                    <Col xs={3}>
                      <ControlLabel className="filter-label">Reason for removal</ControlLabel>
                    </Col>
                    <Col xs={9}>
                      <Field
                        name="data.meta.reason.cancellation_reason"
                        type="text"
                        options={reasons}
                        component={SelectControl}
                        onChange={this.handleOnchangeReason}
                        validate={[isRequired]}
                      />
                    </Col>
                  </Row>
                  {removalReason && removalReason !== 'Other' && (
                    <div>
                      <FieldArray
                        name="data.attributes.travellers"
                        i18n={i18n}
                        product={product}
                        component={MTARemoveTravellers}
                        groupType={groupType}
                        renderDefinition={renderDefinition}
                        change={change}
                        handleRemoveField={this.handleRemoveField}
                        handleRestoreField={this.handleRestoreField}
                        getIndex={this.getIndex}
                        travellersToRemove={this.state.travellersToRemove}
                        isRenewal={false}
                      />
                    </div>
                  )}
                </Grid>
              </div>
            </div>
            <div style={{margin: '10px auto'}}>
              <MTAButtons button1={goBackButton} button2={submitButton}/>
            </div>
          </Form>
        )}

        {removalReason && removalReason === 'Other' && (
          <div className="call-center">
            <div>
              <h3 className="title">WHOOPS!</h3>
              <p>Unfortunately, we have been unable to make the change you have requested.</p>
              <p>
                Please contact us in order to make the change and keep your policy up to date. Details on how to
                contact
                us can be found <a target={'_blank'} style={{ cursor: 'pointer' }}
                                   href={'https://www.admiral.com/contact-us/travel'}>here</a>
              </p>
              <p>It is important that your details are kept up to date, as incorrect information could
                invalidate your
                cover or affect any future claims.</p>
            </div>
          </div>
        )}
      </>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'data.attributes.metadata.scheme_type');
      const travellers = selector(state, 'data.attributes.travellers');
      const groupType = selector(state, 'data.attributes.metadata.traveller_group');
      const values = selector(
        state,
        'data.attributes',
      );
      const removalReason = selector(
        state,
        'data.attributes.metadata.traveller_remove_reason'
      )
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        i18n: state.branding.i18n,
        formValues: values,
        tripType,
        groupType,
        travellers,
        removalReason
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(MTARemoveTravellerForm);

